module.exports = __webpack_public_path__ + "fonts/AkkLgIt_Pro_1.98a21d7.otf";